const accountingEndpoints = {
  bankList: 'accounting/bankaccounts',
  getBankAccount: 'accounting/bankaccounts/{id}',
  closePeriod: 'accounting/closedperiods',
  accountTransactions: 'accounting/accounttransactions',
  accountTransaction: 'accounting/accounttransactions/{id}',
  accountPayable: 'accounting/accountspayable',
  accountReceivable: 'accounting/accountsreceivable',
  agents: 'agents/',
  agent: 'agents/{id}',
  clients: 'clients/',
  client: 'clients/{id}',
  insurers: 'insurers/',
  insurer: 'insurers/{id}',
  clientMoney: 'accounting/clientmoney',
  getClientMoney: 'accounting/clientmoney/{id}',
  agentRemittanceNote: 'accounting/agentremittances',
  insurerRemittanceNote: 'accounting/insurerpayments',
  agentStatment: 'agentstatements/',
  getIncomeWithdrawals: 'accounting/incomewithdrawals/{currencyCode}',
  incomeWithdrawals: 'accounting/incomewithdrawals',
  bankAccountBalance: 'accounting/balances/bankaccount/{bankAccountId}',
  clientMoneyBalance: 'accounting/balances/clientmoney/{currencyCode}',
  bankTransactions: 'accounting/banktransactions',
  bankTransaction: 'accounting/banktransactions/{id}',
  tolerances: 'accounting/tolerances',
  currencys: 'schemes/currencies',
  reconciliations: 'accounting/reconciliations',
  trialBalanceReport: 'accounting/reports/trialbalance/{currencyCode}',
  balanceSheetReport: 'accounting/reports/balancesheet/{currencyCode}',
  profitAndLossReport: 'accounting/reports/profitandloss/{currencyCode}',
  clientageddebts: 'accounting/reports/clientageddebts/{currencyCode}',
  agentageddebts: 'accounting/reports/agentageddebts/{currencyCode}',
  insureragedcredits: 'accounting/reports/insureragedcredits/{currencyCode}',
  funding: '/accounting/reports/funding/{currencyCode}',
  duefromagents: 'accounting/reports/duefromagents/{currencyCode}',
  duefromclients: 'accounting/reports/duefromclients/{currencyCode}',
  duefrominsurers: 'accounting/reports/duefrominsurers/{currencyCode}',
  agentbalances: 'accounting/reports/agentbalances/{currencyCode}',
  trialBalanceDetailReport:
    'accounting/reports/trialbalance/details/{currencyCode}',
  clientmoneycalculation:
    'accounting/reports/clientmoneycalculation/{currencyCode}',
  earnedincome: '/accounting/reports/earnedincome/{currencyCode}',
  unearnedincome: '/accounting/reports/unearnedincome/{currencyCode}',
  accountsReceivablePayments: 'accounting/accountsreceivablepayments',
  accountsPayablePayments: 'accounting/accountspayablepayments',
};

const usersEndpoints = {
  usersadm: 'users/adm',
  users: 'users/',
  getuseremails: 'users/{id}/emailaddresses',
  useremails: 'users/emailaddresses',
  modifyuser: 'users/{id}',
};

const globalEndpoints = {
  site: 'sites/site',
};

const questionsEditorEndpoints = {
  // Gets the scheme data
  SCHEME: 'schemes/{schemeId}',

  // Gets the specified question set using the filename
  SCHEME_QUESTION_SET_FILE: 'questionsets/scheme/{schemeId}/{file}',

  // Publishes a question set for a scheme
  SCHEME_QUESTION_SET_PUBLISH: 'questionsets/scheme/{schemeId}:publish',

  // Gets the specified question set
  SCHEME_QUESTION_SET: 'questionsets/{questionSetId}',

  // Gets a list of the current and past published question sets for a scheme
  SCHEME_QUESTION_SETS: 'questionsets/scheme/{schemeId}',
};

const dataLookups = {
  LOOKUPS_LIST: 'datalookups/',
  LOOKUP: 'datalookups/{id}', // GET / PUT / DELETE
  LOOKUP_FILE: 'datalookups/{id}/file', // GET
  LOOKUP_COLUMNS: 'datalookups/{id}/columns', // GET
  LOOKUP_CONTAINS: 'datalookups/{id}/contains', // GET
};

const authEndpoints = {
  AUTH_TEMPLATES: 'auth/templates', // get
  AUTH_TEMPLATE_NAMES: 'auth/templates/names', // get
  AUTH_TEMPLATE: 'auth/templates/{templateName}', // get
  AUTH_USER: 'auth/users/{id}', // get / patch
  AUTH: 'auth/token', // post
  // machine keys
  AUTH_MACHINE_KEY: 'auth/machine-keys/{id}', // get / delete
  AUTH_MACHINE_KEYS: 'auth/machine-keys', // get / post
  AUTH_REFRESH: 'auth/refresh', // post
};

const documentsEndpoints = {
  DOCUMENT_FILE: 'documents/{documentId}', // get
  DOCUMENTS_LIST: 'documents/',
};

const documentTemplatesEndpoints = {
  DOCUMENT_TEMPLATE: 'documenttemplates/{documentId}',
  DOCUMENT_TEMPLATES: 'documenttemplates/',
};

const emailEndpoints = {
  EMAILS_LIST: 'emails/', // get
  EMAIL_BY_ID: 'emails/{activeEmailId}', // get
};

const insurersEndpoints = {
  INSURER: `insurers/{id}`,
  INSURERS: `insurers/`,
  // INSURER_SCHEME: `insurers/scheme/{schemeId}`, // deprecated
};

const translationsEndpoints = {
  ACTIVE_TRANSLATIONS: 'translations/', // get / patch
  TRANSLATIONS_TEMPLATE: '/translations/template', // get
  LOCALE_TRANSLATIONS: 'translations/{locale}', // get / patch
  PATCH_ADM_TRANSLATIONS: 'translations/{locale}/adm', // patch // adm user only
};

const sitesEndpoints = {
  SITES: 'sites/', // get
  SITE: 'sites/{id}', // get
};

const billingEndpoints = {
  BILLING: 'billing/', // get - ADM ONLY
};

const endpoints = Object.freeze({
  ...globalEndpoints,
  ...questionsEditorEndpoints,
  ...accountingEndpoints,
  ...authEndpoints,
  ...documentsEndpoints,
  ...documentTemplatesEndpoints,
  ...emailEndpoints,
  ...insurersEndpoints,
  ...translationsEndpoints,
  ...dataLookups,
  ...usersEndpoints,
  ...sitesEndpoints,
  ...billingEndpoints,
} as const);

export type Endpoint = (typeof endpoints)[keyof typeof endpoints];
export default endpoints;
